"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var action_button_label_scss_1 = tslib_1.__importDefault(require("./action-button-label.scss"));
var lodash_1 = require("lodash");
var ActionButtonLabel = function (_a) {
    var className = _a.className, label = _a.label, shortLabel = _a.shortLabel;
    return (react_1.default.createElement("span", tslib_1.__assign({ "data-hook": "action-button-label", className: (0, classnames_1.default)(className, action_button_label_scss_1.default.container) }, ((0, lodash_1.isString)(label) && { 'data-label': label }), (shortLabel && { 'data-short-label': shortLabel })), react_1.default.isValidElement(label) && label));
};
exports.default = ActionButtonLabel;
//# sourceMappingURL=action-button-label.js.map